import styles from "./Nickname.module.scss"

import React from "react"

import {Role, useAccount} from "@shared/contexts"

import classNames from "classnames"
import {GROUP} from "../../config";
import {maskName} from "../../modules";

interface Props {
  role: Role
  nickname: string | undefined
  isNicknameStyled: boolean
  isViewer?: boolean
  emoji?: string
}

function Nickname({ role, nickname, isNicknameStyled, isViewer, emoji }: Props) {
  const nicknameColor = getNicknameColor(role)
  const { account } = useAccount()
  const isStreamer = GROUP.STREAMER.includes(account.viewer?.role as string)


  return (
    <strong
      className={classNames({
        [styles[nicknameColor]]: isNicknameStyled,
        [styles.viewer]: isViewer,
      })}
    >
      {maskName(nickname, isStreamer, role, emoji)} {isViewer ? "" : ":"}
    </strong>
  )
}

export default Nickname

function getNicknameColor(role: Role): string {
  // switch (role) {
  //   case "PAID_USER":
  //     return "red"
  //   case "OTHER_PAID_USER":
  //     return "blue"
  //   case "ANONYMOUS":
  //   case "NOT_MATCHED_USER":
  //     return "gray"
  //   default:
  //     return "default"
  // }
  return "default"
}